import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { SidebarContext } from "context/SidebarContext";
import VendorAlotServices from "services/VendorAlotServices";
import { notifyError, notifySuccess } from "utils/toast";

const useVendorAlotSubmit = (
  id,
  tab,
  start_date,
  end_date,
  old_vendor_id,
  package_type,
  va_id,
  vendorAction,
  vendorAllotAction,
) => {
  const { isDrawerOpen, closeDrawer, setIsUpdate } = useContext(SidebarContext);
  const [step, setStep] = useState(1);
  const [driverImageUrl, setDriverImageUrl] = useState("");
  const [licenseImageUrl, setLicenseImageUrl] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [selectedState, setSelectedState] = useState(null);
  const [selectedCity, setSelectedCity] = useState(null);
  const [selectedCountryId, setSelectedCountryId] = useState(null);
  const [selectedCountryCode, setSelectedCountrycode] = useState("");
  const [selectedRadioValueGender, setSelectedRadioValueGender] = useState("");
  const [selectedReferenceNo, setselectedReferenceNo] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  // null = undetermined (trip_went_or_not '0') — neither radio pre-checked,
  // so the form doesn't silently imply "No" was already decided when nothing
  // has actually been confirmed yet.
  const [tripwent, setTrip] = useState(false);
  const [loading, setLoading] = useState(false);
  const [changeReason, setChangeReason] = useState("");
  const {
    register,
    handleSubmit,
    setValue,
    clearErrors,
    trigger,
    formState: { errors },
  } = useForm();
  const adminInfo = localStorage.getItem("adminInfo")
    ? JSON.parse(localStorage.getItem("adminInfo"))
    : null;

  const id_employee = adminInfo?.id ? adminInfo.id : 0;

  const handleCountryChange = (country_code, country_id) => {
    setSelectedCountryId(country_id);
    setSelectedCountrycode(country_code);
  };
  const handleStateChange = (state_id) => {
    setSelectedState(state_id);
  };
  const handleCityChange = (city_id) => {
    setSelectedCity(city_id);
  };
  //console.log(package_type)
  const handleChangeRadioGender = (value) => {
    setSelectedRadioValueGender(value);
  };
  const parseDate = (dateStr) => {
    const [day, month, year] = dateStr.split("-");

    return new Date(`${year}-${month}-${day}`);
  };

  useEffect(() => {
    if (start_date) {
      setStartDate(parseDate(start_date));
      setEndDate(parseDate(end_date));
    }
  }, [start_date, end_date]);
  const handleReferenceChange = (reference_id) => {
    setselectedReferenceNo(String(reference_id)); // Converts the value to a string
  };
  const handleNextStep = async () => {
    await trigger();

    // if (tripwent === null) {
    //   notifyError("Please select Trip Went.");
    //   return;
    // }

    if (tripwent && !startDate) {
      notifyError("Please select Start Date.");
      return;
    }

    if (!changeReason?.trim()) {
      notifyError("Please enter the Reason.");
      return;
    }

    if (Object.keys(errors).length > 0) {
      notifyError("Please provide all the Details.");
      return;
    }

    if (step !== 2) {
      setStep((prev) => prev + 1);
    }
  };
  const handlePreviousStep = async () => {
    await Promise.all([validateForm()]);
    if (Object.keys(errors).length === 0) {
      setStep(step - 1);
    } else {
      return notifyError(`Please provide all the Details`);
    }
  };
  const goToStep = async (stepNumber) => {
    await Promise.all([validateForm()]);
    if (Object.keys(errors).length === 0) {
      setStep(stepNumber);
    } else {
      return notifyError(`Please provide all the Details`);
    }
  };
  const validateForm = async () => {
    await trigger();
    return Object.keys(errors).length;
  };

  // const onSubmit = async (data) => {
  //   setLoading(true);
  //   let trip;
  //   if (
  //     !selectedReferenceNo ||
  //     selectedReferenceNo.trim() === "" ||
  //     selectedReferenceNo === "undefined"
  //   ) {
  //     notifyError("Please select a vendor.");
  //     setLoading(false);
  //     return; // Stop the submission process
  //   }

  //   if (tripwent === true) {
  //     trip = 1;
  //   }
  //   if (tripwent === false) {
  //     trip = 2;
  //   }

  //   try {
  //     const formatDate = (dateString) => {
  //       const date = new Date(dateString);
  //       const day = String(date.getDate()).padStart(2, "0"); // Ensures two digits for day
  //       const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
  //       const year = date.getFullYear();
  //       return `${day}-${month}-${year}`;
  //     };

  //     const adjustedEndDate = new Date(endDate);
  //     // adjustedEndDate.setDate(adjustedEndDate.getDate() - 1);
  //     adjustedEndDate.setDate(adjustedEndDate.getDate());
  //     const finalStartDate = startDate;
  //     const adjustedStartDate = new Date(finalStartDate);
  //     adjustedStartDate.setDate(adjustedStartDate.getDate());

  //     const formattedStartDate = formatDate(adjustedStartDate);
  //     // adjustedEndDate.setDate(adjustedEndDate.getDate() - 1);

  //     // Formatting the adjusted start date
  //     // Formatting the adjusted end date
  //     const formattedEndDate = formatDate(adjustedEndDate);
  //     // Prepare the payload
  //     const payload = {
  //       vendor_id: selectedReferenceNo,
  //       old_vendor_id: old_vendor_id,
  //       va_id: va_id,
  //       start_date: formattedStartDate,
  //       end_date: formattedEndDate,
  //       client_id: id,
  //       trip_went_or_not: trip,
  //       reason: changeReason,
  //       employee_id: id_employee,
  //     };

  //     const allot = {
  //       vendor_id: selectedReferenceNo,
  //       start_date: start_date,
  //       end_date: end_date,
  //       client_id: id,
  //       employee_id: id_employee,
  //       va_id: va_id,
  //     };
  //     setIsSubmitting(true);
  //     // Determine if it's an update or a new entry
  //     if (vendorAction === "modify") {
  //       const res = await VendorAlotServices.ModifyVendor(payload);
  //       notifySuccess(res.message);
  //     }
  //     if (vendorAllotAction === "allot") {
  //       const res = await VendorAlotServices.AlotVendor(allot);
  //       notifySuccess(res.message);
  //     }
  //     setIsUpdate(true);
  //     setIsSubmitting(false);
  //     closeDrawer();
  //   } catch (err) {
  //     notifyError(err?.response?.data?.message || err.message);
  //     setIsSubmitting(false);
  //     // closeDrawer();
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const onSubmit = async (data) => {
    setLoading(true);
    let trip;

    if (
      !selectedReferenceNo ||
      selectedReferenceNo.trim() === "" ||
      selectedReferenceNo === "undefined"
    ) {
      notifyError("Please select a vendor.");
      setLoading(false);
      return;
    }

    if (tripwent === true) {
      trip = 1;
    }

    if (tripwent === false) {
      trip = 2;
    }

    try {
      const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
      };

      const adjustedEndDate = new Date(endDate);
      adjustedEndDate.setDate(adjustedEndDate.getDate());

      const finalStartDate = startDate;
      const adjustedStartDate = new Date(finalStartDate);
      adjustedStartDate.setDate(adjustedStartDate.getDate());

      const formattedStartDate = formatDate(adjustedStartDate);
      const formattedEndDate = formatDate(adjustedEndDate);

      const payload = {
        vendor_id: selectedReferenceNo,
        old_vendor_id: old_vendor_id,
        va_id: va_id,
        start_date: formattedStartDate,
        end_date: formattedEndDate,
        client_id: id,
        trip_went_or_not: trip,
        reason: changeReason,
        employee_id: id_employee,
      };

      const allot = {
        vendor_id: selectedReferenceNo,
        start_date: start_date,
        end_date: end_date,
        client_id: id,
        employee_id: id_employee,
        va_id: va_id,
      };

      setIsSubmitting(true);

      if (vendorAction === "modify") {
        const res = await VendorAlotServices.ModifyVendor(payload);

        if (res.status) {
          notifySuccess(res.message);
        } else {
          notifyError(res.message);
          setIsSubmitting(false);
          return;
        }
      }

      if (vendorAllotAction === "allot") {
        const res = await VendorAlotServices.AlotVendor(allot);

        if (res.status) {
          notifySuccess(res.message);
        } else {
          notifyError(res.message);
          setIsSubmitting(false);
          return;
        }
      }

      setIsUpdate(true);
      setIsSubmitting(false);
      closeDrawer();
    } catch (err) {
      notifyError(
        err?.response?.data?.message || err?.message || "Something went wrong.",
      );
      setIsSubmitting(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const cleanUpData = () => {
      setStep(1);
      setValue("reason", "");
      setValue("client_start_date", "");
      setValue("reason");
      setValue("client_start_date");
      setValue("client_end_date", "");
      setValue("client_end_date");
      clearErrors();
    };

    if (id) {
      (async () => {
        try {
          const result = await VendorAlotServices.getVendorbyClientid(id, {
            service_type: package_type,
          });
          if (result && result.data) {
            const res = result.data;
            setselectedReferenceNo(String(res.vendor_id));
            setValue("vendor_id", res.vendor_id);
          }
        } catch (err) {
          notifyError(err ? err?.response?.data?.message : err.message);
        }
      })();
    }

    // Clean up on close or when no ID
    if (!isDrawerOpen) {
      setStep(1);
      setValue("reason", "");
      setValue("client_start_date", "");
      setValue("reason");
      setValue("client_start_date");
      setValue("client_end_date", "");
      setValue("client_end_date");
      clearErrors();
      return;
    }
    if (!isDrawerOpen || !id) {
      cleanUpData();
    }
  }, [id, start_date, end_date, setValue, isDrawerOpen, clearErrors]);

  return {
    trigger,
    register,
    handleSubmit,
    onSubmit,
    errors,
    handleNextStep,
    step,
    setStep,
    handlePreviousStep,
    goToStep,
    setSelectedRadioValueGender,
    setSelectedCity,
    setSelectedState,
    setSelectedCountryId,
    setSelectedCountrycode,
    setLicenseImageUrl,
    setDriverImageUrl,
    driverImageUrl,
    licenseImageUrl,
    isSubmitting,
    start_date,
    selectedCity,
    selectedState,
    selectedCountryId,
    selectedCountryCode,
    selectedRadioValueGender,
    selectedReferenceNo,
    handleChangeRadioGender,
    handleCityChange,
    handleCountryChange,
    handleStateChange,
    handleReferenceChange,
    tripwent,
    setTrip,
    setStartDate,
    startDate,
    setEndDate,
    loading,
    setLoading,
    endDate,
    changeReason,
    setChangeReason,
  };
};

export default useVendorAlotSubmit;
